module.exports = __webpack_public_path__ + "img/IMG_1961.0ea387d1.jpg";